module.exports = __webpack_public_path__ + "img/human_71.d6671c11.png";